import React from "react";

const FloatingSubscribe = () => {
  return (
    <div className="relative">
      <div className="absolute hidden md:flex left-0 right-0 -top-20 px-4 lg:px-0">
        <div
          className="
            bg-subs w-full max-w-5xl mx-auto
            h-32 md:h-36
            rounded-2xl shadow-lg
            flex items-center justify-between gap-6
            px-6 md:px-10
          "
        >
          <h2 className="text-[#006c63] text-xl md:text-2xl lg:text-3xl font-semibold leading-snug w-2/3">
            Hubungi Kami Untuk Solusi Terbaik!
          </h2>

          <a
            href="https://wa.me/6289507085550"
            target="_blank"
            rel="noopener noreferrer"
            className="
              bg-[#006c63] hover:bg-[#00544e]
              text-white font-medium
              py-3 px-6 md:py-3.5 md:px-8
              rounded-lg shadow-md
              transition-colors duration-200
            "
          >
            Hubungi Sekarang
          </a>
        </div>
      </div>
    </div>
  );
};

export default FloatingSubscribe;
